import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Select from "react-select";

function Sales() {
    const navigate = useNavigate();
    
    const fetchInProgressRef = useRef(false);
    
    // Get today's date
    const getTodayDate = () => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    };

    // Format date to DD-MMM-YYYY (e.g., 12-Dec-2025)
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                           'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    // Format Bill Number with leading zeros
    const formatBillNo = (billId) => {
        if (!billId) return '-';
        return String(billId).padStart(3, '0');
    };

    const attachUserInfo = (fd) => {
        try {
          const stored = sessionStorage.getItem("ldata");
          if (stored) {
            const u = JSON.parse(stored);
            fd.append('user_id',   u.user_id   || '');
            fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
            fd.append('user_role', u.role_id   || u.role_name || '');
          }
        } catch (e) {
          console.warn("attachUserInfo failed:", e);
        }
        return fd;
    };


    // State variables
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentMode, setPaymentMode] = useState('');
    const [paymentAmount, setPaymentAmount] = useState('');
    const [paymentReceivedBy, setPaymentReceivedBy] = useState('');
    const [paymentRemarks, setPaymentRemarks] = useState('');
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [selectedPaymentBill, setSelectedPaymentBill] = useState(null);
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [selectedPrintBill, setSelectedPrintBill] = useState(null);
    const [image, setImage] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    
    const [formData, setFormData] = useState({
        l1: [],
        med_bill_type: 'normal',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        from_date: getTodayDate(),
        to_date: getTodayDate(),
        isAlert: false,
    });

    const [totals, setTotals] = useState({
        totalAmount: 0,
        discountAmount: 0,
        paidAmount: 0,
        dueAmount: 0,
        totalTaxCharges: 0,
    });

    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const [showMedicineModal, setShowMedicineModal] = useState(false);
    const [selectedBillMedicines, setSelectedBillMedicines] = useState([]);
    const [selectedBillInfo, setSelectedBillInfo] = useState(null);

    // FETCH PAYMENT HISTORY
    const fetchPaymentHistory = async (medBillId) => {
        if (!medBillId) return;
        
        try {
            const fd = new FormData();
            fd.append('med_bill_id', medBillId);
            
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getMedPaymentHistoryUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (response.data.status) {
                setPaymentHistory(response.data.records || []);
            }
        } catch (error) {
            console.error("Error fetching payment history:", error);
        }
    };

    // OPEN PAYMENT MODAL
    const openPaymentModal = (bill) => {
        setSelectedPaymentBill(bill);
        setPaymentMode('');
        setPaymentAmount(bill.med_bill_due || '0');
        setPaymentRemarks('');
        fetchPaymentHistory(bill.med_bill_id);
        setShowPaymentModal(true);
    };

    // ADD PAYMENT HANDLER
    const handleAddPayment = async () => {
        const amount = parseFloat(paymentAmount);
        const due = parseFloat(selectedPaymentBill?.med_bill_due || 0);
        
        if (!paymentMode || paymentMode.trim() === '') {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please select a payment mode',
                confirmButtonColor: '#405189'
            });
            return;
        }
        
        if (!paymentAmount || amount <= 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please enter a valid payment amount',
                confirmButtonColor: '#405189'
            });
            return;
        }
        
        if (amount > due) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: `Payment amount cannot exceed due amount (₹${due.toFixed(2)})`,
                confirmButtonColor: '#405189'
            });
            return;
        }
        
        if (!paymentReceivedBy.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please enter received by name',
                confirmButtonColor: '#405189'
            });
            return;
        }
        
        try {
            const fd = new FormData();
            fd.append('med_bill_id', selectedPaymentBill.med_bill_id);
            fd.append('payment_amount', amount);
            fd.append('payment_mode', paymentMode);
            fd.append('payment_received_by', paymentReceivedBy);
            fd.append('payment_remarks', paymentRemarks);
            fd.append('user_id', ldata?.user_id || '1');
            
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.addMedPaymentUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (response.data.status) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: response.data.success || 'Payment added successfully',
                    timer: 2000,
                    showConfirmButton: false
                });
                
                setPaymentAmount('');
                setPaymentRemarks('');
                setPaymentMode('');
                
                fetchPaymentHistory(selectedPaymentBill.med_bill_id);
                initData(); // Refresh list
                
                setTimeout(() => {
                    setShowPaymentModal(false);
                }, 2000);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.success || 'Failed to add payment',
                    confirmButtonColor: '#405189'
                });
            }
        } catch (error) {
            console.error("Payment error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Failed to add payment. Please try again.',
                confirmButtonColor: '#405189'
            });
        }
    };

    // DELETE PAYMENT HANDLER
    const handleDeletePayment = async (paymentId) => {
        const userRoleId = ldata?.role_id || 0;
        
        if (parseInt(userRoleId) !== 1) {
            Swal.fire({
                icon: 'warning',
                title: 'Permission Denied',
                text: 'Only administrators can delete payments',
                confirmButtonColor: '#405189'
            });
            return;
        }
        
        const result = await Swal.fire({
            title: 'Delete Payment?',
            text: "This will reverse the payment and update the due amount.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });
        
        if (!result.isConfirmed) return;
        
        try {
            const fd = new FormData();
            fd.append('payment_id', paymentId);
            fd.append('user_id', ldata?.user_id || '0');
            attachUserInfo(fd);
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.deleteMedPaymentUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (response.data.status) {
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: response.data.success || 'Payment deleted successfully',
                    timer: 2000,
                    showConfirmButton: false
                });
                
                fetchPaymentHistory(selectedPaymentBill.med_bill_id);
                initData(); // Refresh list
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.success || 'Failed to delete payment',
                    confirmButtonColor: '#405189'
                });
            }
        } catch (error) {
            console.error("Delete payment error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Failed to delete payment. Please try again.',
                confirmButtonColor: '#405189'
            });
        }
    };

    const handlePay = (bill) => {
        openPaymentModal(bill);
    };

    const isAdminUser = () => {
        try {
            const raw = sessionStorage.getItem('ldata');
            if (!raw) return false;
            const user = JSON.parse(raw);
            return String(user?.role_id) === '1';
        } catch (e) {
            return false;
        }
    };

    // ✅ Check if user can edit (within 24 hours or admin)
    const canEdit = (billDate) => {
        // Admin can always edit
        if (isAdmin) return true;
        
        // Check if within 24 hours for regular users
        const bill = new Date(billDate);
        const now = new Date();
        const diffInHours = (now - bill) / (1000 * 60 * 60);
        
        return diffInHours <= 24;
    };

    // UPDATED initData with duplicate filtering
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        
        if (roleId === 1 || roleId === "1") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', 'none');
            fd.append('search_key', formData.search_key + "");
            fd.append('med_bill_type', 'all');
            // ✅ If search_key exists → IGNORE date filter
if (formData.search_key && formData.search_key.trim() !== "") {
    fd.append('from_date', "");
    fd.append('to_date', "");
} else {
    fd.append('from_date', formData.from_date || "");
    fd.append('to_date', formData.to_date || "");
}


            try {
                const response = await axios.post(
                    AppConst.BASE_URL + AppConst.getMedBillListUrl, 
                    fd, 
                    {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    }
                );
                
                if (response.data.status) {
                    const records = response.data.records;
                    if (records) {
                        // Filter duplicates before setting state
                        const uniqueRecords = records.filter((record, index, self) =>
                            index === self.findIndex(r => 
                                String(r.med_bill_id) === String(record.med_bill_id)
                            )
                        );
                        
                        console.log("Fetched records:", records.length, "Unique:", uniqueRecords.length);
                        
                        setFormData(prev => ({
                            ...prev,
                            l1: uniqueRecords
                        }));
                    }
                }
            } catch (error) {
                console.error("initData error:", error);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEdit = (item) => {
        if (!canEdit(item.med_bill_date)) {
            Swal.fire({
                icon: 'warning',
                title: 'Cannot Edit',
                text: 'You can only edit sales within 24 hours of creation. Only administrators can edit after 24 hours.',
                confirmButtonColor: '#405189'
            });
            return;
        }

        Swal.fire({
            title: 'Edit Sale?',
            text: `Do you want to edit sale for ${item.med_bill_patient_number}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#405189',
            cancelButtonColor: '#f06548',
            confirmButtonText: 'Yes, Edit',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                sessionStorage.setItem("opd_dt", JSON.stringify(item));
                navigate("/pharmacy_sale");
            }
        });
    };

    // UPDATED delItem with race condition prevention
    const delItem = async (item) => {
        if (!isAdmin) {
            Swal.fire({
                icon: 'error',
                title: 'Access Denied',
                text: 'Only administrators can delete sales records.',
                confirmButtonColor: '#405189'
            });
            return;
        }

        const result = await Swal.fire({
            title: 'Delete Sale?',
            html: `Are you sure you want to delete this sale?<br><strong>Patient: ${item.med_bill_patient_number}</strong><br><strong>Amount: ₹${item.med_bill_final_amt}</strong>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f06548',
            cancelButtonColor: '#405189',
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'Cancel'
        });

        if (!result.isConfirmed) return;

        // Prevent duplicate calls
        if (isDeleting) {
            console.log("Delete already in progress, ignoring duplicate call");
            return;
        }

        setIsDeleting(true);

        const fd = new FormData();
        fd.append('med_bill_id', item.med_bill_id + "");
        attachUserInfo(fd);   
        try {
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.deleteMedBillUrl, 
                fd, 
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            );
            
            if (response.data.status) {
                // Update state directly (no refetch, instant UI update)
                setFormData(prev => ({
                    ...prev,
                    l1: prev.l1.filter(bill => 
                        String(bill.med_bill_id) !== String(item.med_bill_id)
                    )
                }));

                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'Sale record has been deleted.',
                    confirmButtonColor: '#405189',
                    timer: 2000,
                    showConfirmButton: false
                });
                
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.message || 'Failed to delete sale record.',
                    confirmButtonColor: '#405189'
                });
            }
        } catch (error) {
            console.error("Delete error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while deleting.',
                confirmButtonColor: '#405189'
            });
        } finally {
            setIsDeleting(false);
        }
    };

    // UPDATED Auto-fetch with race condition prevention
    useEffect(() => {
        // Skip if delete is in progress or fetch is already running
        if (isDeleting || fetchInProgressRef.current) {
            console.log("Skipping auto-fetch - operation in progress");
            return;
        }

        const timer = setTimeout(() => {
            console.log("Auto-fetch triggered by date/search change");
            fetchInProgressRef.current = true;
            
            initData().finally(() => {
                fetchInProgressRef.current = false;
            });
        }, 300); // 300ms debounce
        
        return () => clearTimeout(timer);
    }, [formData.from_date, formData.to_date, formData.search_key, isDeleting]);

    useEffect(() => {
        // Add z-index styles for SweetAlert in modals
        const style = document.createElement('style');
        style.innerHTML = `
            .swal2-container {
                z-index: 99999 !important;
            }
            .swal2-popup {
                z-index: 99999 !important;
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    useEffect(() => {
        const stored = sessionStorage.getItem("ldata");
        if (stored) {
            const parsed = JSON.parse(stored);
            setPaymentReceivedBy(`${parsed.fname || ''} ${parsed.lname || ''}`.trim());
        }
    }, []);

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }

        return () => {
            console.log('Component unmounted');
        };
    }, []);

    const numberToWords = (num) => {
        if (num === null || num === undefined || isNaN(num)) return '';
    
        // convert to integer rupees
        num = Math.round(Number(num));
    
        const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ',
            'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ',
            'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    
        const b = ['', '', 'twenty ', 'thirty ', 'forty ', 'fifty ',
            'sixty ', 'seventy ', 'eighty ', 'ninety '];
    
        if (num === 0) return 'Zero Only';
    
        if (num.toString().length > 9) return 'Overflow';
    
        const n = ('000000000' + num)
            .slice(-9)
            .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    
        if (!n) return '';
    
        let str = '';
    
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + a[n[1][1]]) + 'Crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + 'Lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + 'Thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + a[n[4][1]]) + 'Hundred ' : '';
        str += (n[5] != 0)
            ? ((str !== '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + a[n[5][1]])
            : '';
    
        return str.trim()
            .replace(/\s+/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase()) + ' Only';
    };

    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=pharmacy`
            );

            if (res.data.status) {
                const data = res.data;
                setImage(data.header_logo);
            }
        }
        catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    useEffect(() => {
        fetchConfigData()
    }, []);

    const imageUrlToBase64 = async (url) => {
        if (!url) {
            console.error("Image URL is empty or invalid.");
            return null;
        }

        try {
            const response = await fetch(url);
            if (!response.ok) {
                console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
                return null;
            }

            const blob = await response.blob();

            if (!blob.type.startsWith('image/')) {
                console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
                return null;
            }

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error fetching or converting image:", error);
            return null;
        }
    };

    const formatBillDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
    
        const day = String(d.getDate()).padStart(2, '0');
        const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        const month = monthNames[d.getMonth()];
        const year = d.getFullYear();
    
        return `${day}-${month}-${year}`;
    };
    


    const formatPdfPaymentDateTime = (dateStr) => {
        if (!dateStr) return '';
    
        const d = new Date(dateStr);
        if (isNaN(d)) return '';
    
        const day = String(d.getDate()).padStart(2, '0');
        const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        const month = months[d.getMonth()];
        const year = d.getFullYear();
    
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
    
        return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
    };
    
    
    const formatAge = (y = 0, m = 0, d = 0) => {
        const parts = [];
        if (y > 0) parts.push(`${y} Year${y > 1 ? 's' : ''}`);
        if (m > 0) parts.push(`${m} Month${m > 1 ? 's' : ''}`);
        if (d > 0) parts.push(`${d} Day${d > 1 ? 's' : ''}`);
        return parts.length ? parts.join(' ') : '0 Day';
    };
    
    // OPEN PRINT OPTIONS MODAL
    const openPrintOptionsModal = (bill) => {
        setSelectedPrintBill(bill);
        setShowPrintModal(true);
    };

    // GENERATE PHARMACY BILL PDF WITH PAYMENT HISTORY
    const generatePharmacyBillWithPayments = async (bill) => {
        try {
            // Fetch payment history
            let paymentHistory = [];
            const fd = new FormData();
            fd.append('med_bill_id', bill.med_bill_id);
            
            const historyResponse = await axios.post(
                AppConst.BASE_URL + AppConst.getMedPaymentHistoryUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (historyResponse.data.status) {
                paymentHistory = historyResponse.data.records || [];
            }

            const doc = new jsPDF("p", "pt", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();
            const margin = 30;
            let y = 40;

            // Header Image
            const headerImageBase64 = await imageUrlToBase64(image);
            const headerImageHeight = 80;

            if (headerImageBase64) {
                doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
            }

            y = headerImageHeight + 20;
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text("Pharmacy Bill", pageWidth / 2, y, { align: "center" });
            y += 10;
            doc.rect(margin, y, pageWidth - 2 * margin, 80);

            let leftX = margin + 10;
            let rightX = pageWidth / 2 + 40;
            let lineY = y + 15;

            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Bill To:", leftX, lineY);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);

            doc.text(`Patient Name : ${bill.med_bill_patient_number || 'Walk-in Customer'}`, leftX, (lineY += 15));

            const ageText = formatAge(bill.med_bill_age_year, bill.med_bill_age_month, bill.med_bill_age_day);
            doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
            doc.text(`Mobile : ${bill.med_bill_phone_number || ''}`, leftX, (lineY += 15));
            doc.text(`Doctor : ${bill.med_bill_doctor || bill.med_bill_ref_doctor || '-'}`, leftX, (lineY += 15));

            lineY = y + 15;

            const grandTotal = parseFloat(bill.med_bill_final_amt || 0);
            const paid = parseFloat(bill.med_bill_paid || 0);

            let paymentStatus = "Not Paid";
            if (paid >= grandTotal) paymentStatus = "Paid";
            else if (paid > 0) paymentStatus = "Partial Paid";

            doc.text(`UHID : ${bill.med_bill_ipd_number || ''}`, rightX, lineY);
            doc.text(`Bill No : ${formatBillNo(bill.med_bill_id)}`, rightX, (lineY += 15));
            doc.text(`Bill Date : ${formatBillDate(bill.med_bill_date)}`, rightX, (lineY += 15));
            doc.text(`Payment Status : ${paymentStatus}`, rightX, (lineY += 15));

            y += 100;

            // Items Table
            const tableHeaders = [["Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"]];

            const tableBody = (bill.items || []).map((med, index) => {
                const qty = parseInt(med.med_bill_item_qty || 0);
                const mrp = parseFloat(med.med_bill_item_mrp || 0);
                const discount = parseFloat(med.med_bill_item_discount || 0);
                const total = (mrp - discount) * qty;

                return [
                    index + 1,
                    med.med_bill_item_medicine || '',
                    (med.med_bill_item_is_loose == 1 ? "Loose" : "Package"),
                    qty,
                    med.med_bill_item_batch || '',
                    med.med_bill_item_exp || '',
                    med.med_bill_item_hsn || '',
                    discount.toFixed(2),
                    mrp.toFixed(2),
                    total.toFixed(2),
                ];
            });

            autoTable(doc, {
                startY: y,
                head: tableHeaders,
                body: tableBody,
                theme: "grid",
                styles: { fontSize: 9, cellPadding: 4 },
                headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
            });

            y = doc.lastAutoTable.finalY + 15;

            // PAYMENT HISTORY SECTION
            if (paymentHistory.length > 0) {
                doc.setFont("helvetica", "bold");
                doc.setFontSize(12);
                doc.text("Payment History", margin, y);
                y += 15;

                const paymentHeaders = [["Date & Time", "Mode", "Amount", "Received By"]];
                const paymentBody = paymentHistory.map(payment => [
                    formatPdfPaymentDateTime(payment.payment_datetime), // ✅ 01 Jan 2026
                    payment.payment_mode,
                    `${parseFloat(payment.payment_amount).toFixed(2)}`,
                    payment.payment_received_by
                ]);
                

                autoTable(doc, {
                    startY: y,
                    head: paymentHeaders,
                    body: paymentBody,
                    theme: "grid",
                    styles: { fontSize: 9, cellPadding: 4 },
                    headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
                });

                y = doc.lastAutoTable.finalY + 15;
            }

            // Totals Section
            const totalTax = (bill.items || []).reduce((sum, i) => sum + parseFloat(i.med_bill_item_tax_amt || 0), 0);
            const subtotal = parseFloat(bill.med_bill_total || 0);
            const discountAll = parseFloat(bill.med_bill_discount_amt || 0);
            const due = parseFloat(bill.med_bill_due || 0);

            doc.setFontSize(10);
            doc.text(`Subtotal`, pageWidth - margin - 200, y);
            doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${totalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.text(`Discount`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${discountAll.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.setFont("helvetica", "bold");
            doc.text(`Grand Total`, pageWidth - margin - 200, (y += 20));
            doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.setFont("helvetica", "normal");
            doc.text(`Paid`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${paid.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.text(`Due`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${due.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            y += 30;
            doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
            y += 25;
            doc.setFont("helvetica", "bold");
            doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });

            window.open(doc.output("bloburl"), "_blank");
        } catch (error) {
            console.error("PDF generation error:", error);
            Swal.fire('Error', 'Failed to generate PDF', 'error');
        }
    };

    // GENERATE RETURN BILL PDF
    const generateReturnBillPdf = async (originalBillId) => {
        try {
            // Fetch return bill using new return table endpoint
            const fd = new FormData();
            fd.append('search_key', '');
            fd.append('original_bill_id', originalBillId);

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getReturnListUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (!response.data.status || !response.data.records || response.data.records.length === 0) {
                Swal.fire({
                    icon: 'info',
                    title: 'No Return Bill',
                    text: 'No return bill found for this sale',
                    confirmButtonColor: '#405189'
                });
                return;
            }

            const returnBill = response.data.records.find(r => 
                parseInt(r.med_bill_return_original_bill_id) === parseInt(originalBillId)
            );

            if (!returnBill) {
                Swal.fire({
                    icon: 'info',
                    title: 'No Return Bill',
                    text: 'No return bill found for this sale',
                    confirmButtonColor: '#405189'
                });
                return;
            }

            // Fetch return items
            const itemsFd = new FormData();
            itemsFd.append('return_id', returnBill.med_bill_return_id);

            const itemsResponse = await axios.post(
                AppConst.BASE_URL + AppConst.getReturnDetailsUrl,
                itemsFd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            const returnItems = itemsResponse.data.return_items || [];

            const doc = new jsPDF("p", "pt", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();
            const margin = 30;
            let y = 40;

            const headerImageBase64 = await imageUrlToBase64(image);
            const headerImageHeight = 80;

            if (headerImageBase64) {
                doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
            }

            y = headerImageHeight + 20;
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text("Pharmacy Return Bill", pageWidth / 2, y, { align: "center" });
            y += 10;
            doc.rect(margin, y, pageWidth - 2 * margin, 95);

            let leftX = margin + 10;
            let rightX = pageWidth / 2 + 40;
            let lineY = y + 15;

            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Return Details:", leftX, lineY);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);

            doc.text(`Patient Name : ${returnBill.med_bill_return_patient_name || 'Walk-in Customer'}`, leftX, (lineY += 15));

            const ageText = formatAge(
                returnBill.med_bill_return_age_year, 
                returnBill.med_bill_return_age_month, 
                returnBill.med_bill_return_age_day
            );
            doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
            doc.text(`Mobile : ${returnBill.med_bill_return_phone || ''}`, leftX, (lineY += 15));
            doc.text(`Doctor : ${returnBill.med_bill_return_doctor || returnBill.med_bill_return_ref_doctor || '-'}`, leftX, (lineY += 15));
            doc.text(`Return Reason : ${returnBill.med_bill_return_reason || '-'}`, leftX, (lineY += 15));

            lineY = y + 15;

            doc.text(`UHID : ${returnBill.med_bill_return_original_bill_number || ''}`, rightX, lineY);
            doc.text(`Return Bill No : ${returnBill.med_bill_return_bill_number || '-'}`, rightX, (lineY += 15));
            doc.text(`Original Bill No : ${formatBillNo(originalBillId)}`, rightX, (lineY += 15));
            doc.text(`Return Date : ${formatBillDate(returnBill.med_bill_return_date)}`, rightX, (lineY += 15));
            doc.setFont("helvetica", "bold");
            doc.text(`Bill Type : RETURN`, rightX, (lineY += 15));
            doc.setFont("helvetica", "normal");

            y += 115;

            const tableHeaders = [["Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"]];

            const tableBody = returnItems.map((med, index) => {
                const qty = parseInt(med.med_bill_return_item_qty || 0);
                const mrp = parseFloat(med.med_bill_return_item_mrp || 0);
                const discount = parseFloat(med.med_bill_return_item_discount || 0);
                const total = (mrp - discount) * qty;

                return [
                    index + 1,
                    med.med_bill_return_item_medicine || '',
                    (med.med_bill_return_item_is_loose == 1 ? "Loose" : "Package"),
                    qty,
                    med.med_bill_return_item_batch || '',
                    med.med_bill_return_item_exp || '',
                    med.med_bill_return_item_hsn || '',
                    discount.toFixed(2),
                    mrp.toFixed(2),
                    total.toFixed(2),
                ];
            });

            autoTable(doc, {
                startY: y,
                head: tableHeaders,
                body: tableBody,
                theme: "grid",
                styles: { fontSize: 9, cellPadding: 4 },
                headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
            });

            y = doc.lastAutoTable.finalY + 15;

            const totalTax = returnItems.reduce((sum, i) => sum + parseFloat(i.med_bill_return_item_tax_amt || 0), 0);
            const subtotal = parseFloat(returnBill.med_bill_return_total || 0);
            const grandTotal = parseFloat(returnBill.med_bill_return_final_amt || 0);

            doc.setFontSize(10);
            doc.text(`Subtotal`, pageWidth - margin - 200, y);
            doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${totalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.setFont("helvetica", "bold");
            doc.text(`Total Return Amount`, pageWidth - margin - 200, (y += 20));
            doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            y += 30;
            doc.setFont("helvetica", "normal");
            doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
            
            y += 25;
            doc.setFont("helvetica", "italic");
            doc.setFontSize(8);
            doc.text("Note: This is a return bill. Amount will be refunded as per store policy.", margin, y);
            
            y += 20;
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });

            window.open(doc.output("bloburl"), "_blank");
        } catch (error) {
            console.error("Return PDF error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to generate return bill PDF',
                confirmButtonColor: '#405189'
            });
        }
    };

    // HANDLE PRINT OPTION SELECTION
    const handlePrintSelection = async (option) => {
        setShowPrintModal(false);
        
        if (option === 'pharmacy') {
            await generatePharmacyBillWithPayments(selectedPrintBill);
        } else if (option === 'return') {
            await generateReturnBillPdf(selectedPrintBill.med_bill_id);
        } else if (option === 'all') {
            await generateCombinedBillPdf(selectedPrintBill);
        }
    };

    // NEW FUNCTION: GENERATE COMBINED PDF WITH BOTH BILLS
    const generateCombinedBillPdf = async (bill) => {
        try {
            // Fetch payment history
            let paymentHistory = [];
            const fd = new FormData();
            fd.append('med_bill_id', bill.med_bill_id);
            
            const historyResponse = await axios.post(
                AppConst.BASE_URL + AppConst.getMedPaymentHistoryUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            if (historyResponse.data.status) {
                paymentHistory = historyResponse.data.records || [];
            }

            // Fetch return bill
            const returnFd = new FormData();
            returnFd.append('search_key', '');
            returnFd.append('original_bill_id', bill.med_bill_id);

            const returnResponse = await axios.post(
                AppConst.BASE_URL + AppConst.getReturnListUrl,
                returnFd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            let returnBill = null;
            let returnItems = [];

            if (returnResponse.data.status && returnResponse.data.records && returnResponse.data.records.length > 0) {
                returnBill = returnResponse.data.records.find(r => 
                    parseInt(r.med_bill_return_original_bill_id) === parseInt(bill.med_bill_id)
                );

                if (returnBill) {
                    const itemsFd = new FormData();
                    itemsFd.append('return_id', returnBill.med_bill_return_id);

                    const itemsResponse = await axios.post(
                        AppConst.BASE_URL + AppConst.getReturnDetailsUrl,
                        itemsFd,
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                    );

                    returnItems = itemsResponse.data.return_items || [];
                }
            }

            const doc = new jsPDF("p", "pt", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const margin = 30;
            let y = 40;

            // ============== PAGE 1: PHARMACY BILL ==============
            
            const headerImageBase64 = await imageUrlToBase64(image);
            const headerImageHeight = 80;

            if (headerImageBase64) {
                doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
            }

            y = headerImageHeight + 20;
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text("Pharmacy Bill", pageWidth / 2, y, { align: "center" });
            y += 10;
            doc.rect(margin, y, pageWidth - 2 * margin, 80);

            let leftX = margin + 10;
            let rightX = pageWidth / 2 + 40;
            let lineY = y + 15;

            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Bill To:", leftX, lineY);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);

            doc.text(`Patient Name : ${bill.med_bill_patient_number || 'Walk-in Customer'}`, leftX, (lineY += 15));

            const ageText = formatAge(bill.med_bill_age_year, bill.med_bill_age_month, bill.med_bill_age_day);
            doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
            doc.text(`Mobile : ${bill.med_bill_phone_number || ''}`, leftX, (lineY += 15));
            doc.text(`Doctor : ${bill.med_bill_doctor || bill.med_bill_ref_doctor || '-'}`, leftX, (lineY += 15));

            lineY = y + 15;

            const grandTotal = parseFloat(bill.med_bill_final_amt || 0);
            const paid = parseFloat(bill.med_bill_paid || 0);

            let paymentStatus = "Not Paid";
            if (paid >= grandTotal) paymentStatus = "Paid";
            else if (paid > 0) paymentStatus = "Partial Paid";

            doc.text(`UHID : ${bill.med_bill_ipd_number || ''}`, rightX, lineY);
            doc.text(`Bill No : ${formatBillNo(bill.med_bill_id)}`, rightX, (lineY += 15));
            doc.text(`Bill Date : ${formatBillDate(bill.med_bill_date)}`, rightX, (lineY += 15));
            doc.text(`Payment Status : ${paymentStatus}`, rightX, (lineY += 15));

            y += 100;

            // Items Table
            const tableHeaders = [["Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"]];

            const tableBody = (bill.items || []).map((med, index) => {
                const qty = parseInt(med.med_bill_item_qty || 0);
                const mrp = parseFloat(med.med_bill_item_mrp || 0);
                const discount = parseFloat(med.med_bill_item_discount || 0);
                const total = (mrp - discount) * qty;

                return [
                    index + 1,
                    med.med_bill_item_medicine || '',
                    (med.med_bill_item_is_loose == 1 ? "Loose" : "Package"),
                    qty,
                    med.med_bill_item_batch || '',
                    med.med_bill_item_exp || '',
                    med.med_bill_item_hsn || '',
                    discount.toFixed(2),
                    mrp.toFixed(2),
                    total.toFixed(2),
                ];
            });

            autoTable(doc, {
                startY: y,
                head: tableHeaders,
                body: tableBody,
                theme: "grid",
                styles: { fontSize: 9, cellPadding: 4 },
                headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
            });

            y = doc.lastAutoTable.finalY + 15;

            // Payment History
            if (paymentHistory.length > 0) {
                doc.setFont("helvetica", "bold");
                doc.setFontSize(12);
                doc.text("Payment History", margin, y);
                y += 15;

                const paymentHeaders = [["Date & Time", "Mode", "Amount", "Received By"]];
                const paymentBody = paymentHistory.map(payment => [
                    formatPdfPaymentDateTime(payment.payment_datetime), // ✅ 01 Jan 2026
                    payment.payment_mode,
                    `${parseFloat(payment.payment_amount).toFixed(2)}`,
                    payment.payment_received_by
                ]);
                

                autoTable(doc, {
                    startY: y,
                    head: paymentHeaders,
                    body: paymentBody,
                    theme: "grid",
                    styles: { fontSize: 9, cellPadding: 4 },
                    headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
                });

                y = doc.lastAutoTable.finalY + 15;
            }

            // Totals
            const totalTax = (bill.items || []).reduce((sum, i) => sum + parseFloat(i.med_bill_item_tax_amt || 0), 0);
            const subtotal = parseFloat(bill.med_bill_total || 0);
            const discountAll = parseFloat(bill.med_bill_discount_amt || 0);
            const due = parseFloat(bill.med_bill_due || 0);

            doc.setFontSize(10);
            doc.text(`Subtotal`, pageWidth - margin - 200, y);
            doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${totalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.text(`Discount`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${discountAll.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.setFont("helvetica", "bold");
            doc.text(`Grand Total`, pageWidth - margin - 200, (y += 20));
            doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.setFont("helvetica", "normal");
            doc.text(`Paid`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${paid.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            doc.text(`Due`, pageWidth - margin - 200, (y += 15));
            doc.text(`Rs ${due.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

            y += 30;
            doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
            y += 25;
            doc.setFont("helvetica", "bold");
            doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });

            // ============== PAGE 2: RETURN BILL (IF EXISTS) ==============
            
            if (returnBill && returnItems.length > 0) {
                doc.addPage();
                y = 40;

                if (headerImageBase64) {
                    doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
                }

                y = headerImageHeight + 20;
                doc.setFont("helvetica", "bold");
                doc.setFontSize(16);
                doc.text("Pharmacy Return Bill", pageWidth / 2, y, { align: "center" });
                y += 10;
                doc.rect(margin, y, pageWidth - 2 * margin, 95);

                leftX = margin + 10;
                rightX = pageWidth / 2 + 40;
                lineY = y + 15;

                doc.setFont("helvetica", "bold");
                doc.setFontSize(10);
                doc.text("Return Details:", leftX, lineY);

                doc.setFont("helvetica", "normal");
                doc.setFontSize(9);

                doc.text(`Patient Name : ${returnBill.med_bill_return_patient_name || 'Walk-in Customer'}`, leftX, (lineY += 15));

                const returnAgeText = formatAge(
                    returnBill.med_bill_return_age_year, 
                    returnBill.med_bill_return_age_month, 
                    returnBill.med_bill_return_age_day
                );
                doc.text(`Age : ${returnAgeText}`, leftX, (lineY += 15));
                doc.text(`Mobile : ${returnBill.med_bill_return_phone || ''}`, leftX, (lineY += 15));
                doc.text(`Doctor : ${returnBill.med_bill_return_doctor || returnBill.med_bill_return_ref_doctor || '-'}`, leftX, (lineY += 15));
                doc.text(`Return Reason : ${returnBill.med_bill_return_reason || '-'}`, leftX, (lineY += 15));

                lineY = y + 15;

                doc.text(`UHID : ${returnBill.med_bill_return_original_bill_number || ''}`, rightX, lineY);
                doc.text(`Return Bill No : ${returnBill.med_bill_return_bill_number || '-'}`, rightX, (lineY += 15));
                doc.text(`Original Bill No : ${formatBillNo(bill.med_bill_id)}`, rightX, (lineY += 15));
                doc.text(`Return Date : ${formatBillDate(returnBill.med_bill_return_date)}`, rightX, (lineY += 15));
                doc.setFont("helvetica", "bold");
                doc.text(`Bill Type : RETURN`, rightX, (lineY += 15));
                doc.setFont("helvetica", "normal");

                y += 115;

                const returnTableHeaders = [["Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"]];

                const returnTableBody = returnItems.map((med, index) => {
                    const qty = parseInt(med.med_bill_return_item_qty || 0);
                    const mrp = parseFloat(med.med_bill_return_item_mrp || 0);
                    const discount = parseFloat(med.med_bill_return_item_discount || 0);
                    const total = (mrp - discount) * qty;

                    return [
                        index + 1,
                        med.med_bill_return_item_medicine || '',
                        (med.med_bill_return_item_is_loose == 1 ? "Loose" : "Package"),
                        qty,
                        med.med_bill_return_item_batch || '',
                        med.med_bill_return_item_exp || '',
                        med.med_bill_return_item_hsn || '',
                        discount.toFixed(2),
                        mrp.toFixed(2),
                        total.toFixed(2),
                    ];
                });

                autoTable(doc, {
                    startY: y,
                    head: returnTableHeaders,
                    body: returnTableBody,
                    theme: "grid",
                    styles: { fontSize: 9, cellPadding: 4 },
                    headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
                });

                y = doc.lastAutoTable.finalY + 15;

                const returnTotalTax = returnItems.reduce((sum, i) => sum + parseFloat(i.med_bill_return_item_tax_amt || 0), 0);
                const returnSubtotal = parseFloat(returnBill.med_bill_return_total || 0);
                const returnGrandTotal = parseFloat(returnBill.med_bill_return_final_amt || 0);

                doc.setFontSize(10);
                doc.text(`Subtotal`, pageWidth - margin - 200, y);
                doc.text(`Rs ${returnSubtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

                doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
                doc.text(`Rs ${returnTotalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

                doc.setFont("helvetica", "bold");
                doc.text(`Total Return Amount`, pageWidth - margin - 200, (y += 20));
                doc.text(`Rs ${returnGrandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

                y += 30;
                doc.setFont("helvetica", "normal");
                doc.text(`Amount in Words: ${numberToWords(returnGrandTotal)}`, margin, y);
                
                y += 25;
                doc.setFont("helvetica", "italic");
                doc.setFontSize(8);
                doc.text("Note: This is a return bill. Amount will be refunded as per store policy.", margin, y);
                
                y += 20;
                doc.setFont("helvetica", "bold");
                doc.setFontSize(10);
                doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });
            }

            window.open(doc.output("bloburl"), "_blank");
        } catch (error) {
            console.error("Combined PDF error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to generate combined PDF',
                confirmButtonColor: '#405189'
            });
        }
    };

    const handleViewMedicines = (row) => {
        setSelectedBillInfo(row);
        setSelectedBillMedicines(row.items || []);
        setShowMedicineModal(true);
    };

    const closeMedicineModal = () => {
        setShowMedicineModal(false);
        setSelectedBillMedicines([]);
        setSelectedBillInfo(null);
    };

    useEffect(() => {
        let totalAmount = 0,
            discountAmount = 0,
            paidAmount = 0,
            dueAmount = 0,
            totalTaxCharges = 0,
            totalGrossValue = 0;

        const toNum = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        formData.l1.forEach((bill) => {
            totalAmount += toNum(bill.med_bill_total);
            discountAmount += toNum(bill.med_bill_discount_amt);
            paidAmount += toNum(bill.med_bill_paid);
            dueAmount += toNum(bill.med_bill_due);

            if (bill.items && bill.items.length > 0) {
                bill.items.forEach((med) => {
                    totalTaxCharges += toNum(med.med_bill_item_mrp) * toNum(med.med_bill_item_strips);
                    totalGrossValue += toNum(med.med_bill_item_mrp);
                });
            }
        });

        setTotals({
            totalAmount,
            discountAmount,
            paidAmount,
            dueAmount,
            totalTaxCharges,
            totalGrossValue,
        });
    }, [formData.l1]);

    // DataTable Columns
    const columns = [
        {
            name: 'Actions',
            width: '260px',
            cell: (row) => {
                const admin = isAdminUser();
                const due = parseFloat(row.med_bill_due || 0);
                const canEditThis = canEdit(row.med_bill_date); // ✅ Check if user can edit (24hrs or admin)
            
                return (
                    <div className="d-flex gap-1">
                
                        {/* VIEW */}
                        <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleViewMedicines(row)}
                            title="View Medicines"
                        >
                            <i className="ri-eye-line"></i>
                        </button>
                
                        {/* PRINT */}
                        <button
                            className="btn btn-sm btn-outline-info"
                            onClick={() => openPrintOptionsModal(row)}
                            title="Print Bill"
                        >
                            <i className="ri-printer-line">Print</i>
                        </button>
                
                        {/* PAY (ONLY IF DUE > 0) */}
                        {due > 0 && (
                            <button
                                className="btn btn-sm btn-outline-warning"
                                onClick={() => handlePay(row)}
                                title="Add Payment"
                            >
                                Pay <i className="ri-money-rupee-circle-line"></i>
                            </button>
                        )}
                
                        {/* EDIT (24hrs for all users, always for admin) */}
                        <button
                            className="btn btn-sm btn-outline-success"
                            disabled={!canEditThis}
                            style={{ opacity: canEditThis ? 1 : 0.5 }}
                            onClick={() => handleEdit(row)}
                            title={canEditThis ? "Edit Sale" : "Can only edit within 24 hours (Admin can always edit)"}
                        >
                            <i className="ri-pencil-line"></i>
                        </button>
                
                        {/* DELETE (ADMIN ONLY) */}
                        {/* <button
                            className="btn btn-sm btn-outline-danger"
                            disabled={!admin}
                            style={{ opacity: admin ? 1 : 0.5 }}
                            onClick={() => admin ? delItem(row) : Swal.fire("Only admin can delete")}
                            title={admin ? "Delete Sale" : "Only admin can delete"}
                        >
                            <i className="ri-delete-bin-line"></i>
                        </button> */}
                
                    </div>
                );
            },
            ignoreRowClick: true,
            button: true
        },
        {
            name: 'Bill No',
            selector: row => row.med_bill_id,
            sortable: true,
            cell: row => formatBillNo(row.med_bill_id),
            width: '100px',
        },


        {
            name: 'Status',
            sortable: true,
            width: '120px',
            cell: (row) => {
                const paid = parseFloat(row.med_bill_paid || 0);
                const due = parseFloat(row.med_bill_due || 0);
        
                // 🔴 FULL DUE
                if (due > 0 && paid === 0) {
                    return (
                        <span className="badge bg-danger">
                            DUE
                        </span>
                    );
                }
        
                // 🟢 FULL PAID
                if (due === 0) {
                    return (
                        <span className="badge bg-success">
                            PAID
                        </span>
                    );
                }
        
                // 🟡 PARTIAL
                return (
                    <span className="badge bg-warning text-dark">
                        PARTIAL
                    </span>
                );
            }
        },
        
        {
            name: 'Sr. No.',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'UHID',
            selector: row => row.med_bill_ipd_number,
            sortable: true,
            wrap: true,
            width: '180px',
        },
        {
            name: 'Patient',
            selector: row => row.med_bill_patient_number,
            sortable: true,
            wrap: true,
            width: '180px',
        },
        {
            name: 'Referred Doctor',
            selector: row => row.med_bill_ref_doctor,
            sortable: true,
            wrap: true,
            width: '200px',
        },
        {
            name: 'Billing Date',
            selector: row => row.med_bill_date,
            sortable: true,
            cell: row => formatDate(row.med_bill_date),
            width: '200px',
        },
        {
            name: 'Discount',
            selector: row => row.med_bill_discount_amt || "0.00",
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_discount_amt || 0).toFixed(2)}`
        },
        {
            name: 'Paid',
            selector: row => row.med_bill_paid,
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_paid || 0).toFixed(2)}`
        },
        {
            name: 'Due',
            selector: row => row.med_bill_due,
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_due || 0).toFixed(2)}`
        },
        {
            name: 'Total',
            selector: row => row.med_bill_final_amt,
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_final_amt || 0).toFixed(2)}`
        },
        {
            name: 'Last Used',
            selector: row => row.user_display,
            sortable: true,
            cell: row => row.user_display || '-',
            width: '180px'
        },
    ];

    // Custom styles for DataTable
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#f1f5fb',
                borderBottom: '2px solid #dee2e6',
                fontSize: '15px',
                fontWeight: '700',
                color: '#405189',
            },
        },
        headCells: {
            style: {
                paddingLeft: '14px',
                paddingRight: '14px',
            },
        },
        rows: {
            style: {
                fontSize: '16px',
                minHeight: '58px',
            },
        },
        cells: {
            style: {
                paddingLeft: '14px',
                paddingRight: '14px',
                fontSize: '15px',
                lineHeight: '55px'
            },
        },
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Sales</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="d-flex gap-1 flex-wrap">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    sessionStorage.removeItem("opd_dt");
                                                    navigate("/pharmacy_sale");
                                                }}
                                                className="btn btn-success add-btn"
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i> Add Sale
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-3">
                                            <label className="form-label">From Date</label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="from_date"
                                                onChange={handleChange}
                                                value={formData.from_date}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">To Date</label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="to_date"
                                                onChange={handleChange}
                                                value={formData.to_date}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Search</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="search_key"
                                                placeholder="Search by name, UHID, mobile..."
                                                onChange={handleChange}
                                                value={formData.search_key}
                                                onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), initData())}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">&nbsp;</label>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        search_key: "",
                                                        from_date: getTodayDate(),
                                                        to_date: getTodayDate(),
                                                    }));
                                                }}
                                                className="btn btn-info w-100"
                                            >
                                                <i className="ri-refresh-line me-1"></i> Clear
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="card-body pt-0">
                                <DataTable
                                    columns={columns}
                                    data={formData.l1}
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    highlightOnHover
                                    striped
                                    responsive
                                    customStyles={customStyles}
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-file-list-line fs-1 text-muted"></i>
                                            <p className="mt-3">No sales records found</p>
                                        </div>
                                    }
                                />

                                <div className="mt-3 p-3 bg-light rounded">
                                    <div className="row text-center">
                                        <div className="col-md-3">
                                            <strong>Total Amount:</strong>
                                            <div className="fs-5 text-primary">₹{totals.totalAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Paid Amount:</strong>
                                            <div className="fs-5 text-success">₹{totals.paidAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Due Amount:</strong>
                                            <div className="fs-5 text-danger">₹{totals.dueAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Total Discount:</strong>
                                            <div className="fs-5 text-info">₹{totals.discountAmount.toFixed(2)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Medicine Details Modal */}
            {showMedicineModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="ri-medicine-bottle-line me-2"></i>
                                    Medicine Details - {selectedBillInfo?.med_bill_ipd_number}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={closeMedicineModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3 p-3 bg-light rounded">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <strong>Patient:</strong> {selectedBillInfo?.med_bill_patient_number}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Date:</strong> {formatDate(selectedBillInfo?.med_bill_date)}
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Sr.</th>
                                                <th>Medicine Name</th>
                                                <th>Pack</th>
                                                <th>Batch</th>
                                                <th>Qty</th>
                                                <th>MRP</th>
                                                <th>Discount</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedBillMedicines.length > 0 ? (
                                                selectedBillMedicines.map((med, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{med.med_bill_item_medicine}</td>
                                                        <td>
                                                            {(med.med_bill_item_is_loose === "1" || med.med_bill_item_is_loose === 1) 
                                                                ? "Loose" 
                                                                : "Package"}
                                                        </td>
                                                        <td>{med.med_bill_item_batch}</td>
                                                        <td>{med.med_bill_item_qty}</td>
                                                        <td>₹{parseFloat(med.med_bill_item_mrp || 0).toFixed(2)}</td>
                                                        <td>₹{parseFloat(med.med_bill_item_discount || 0).toFixed(2)}</td>
                                                        <td>₹{parseFloat(med.med_bill_item_total || 0).toFixed(2)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">No medicines found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                        {selectedBillMedicines.length > 0 && (
                                            <tfoot className="table-light">
                                                <tr>
                                                    <td colSpan="7" className="text-end"><strong>Total:</strong></td>
                                                    <td>
                                                        <strong>
                                                            ₹{selectedBillMedicines.reduce((sum, med) => 
                                                                sum + parseFloat(med.med_bill_item_total || 0), 0
                                                            ).toFixed(2)}
                                                        </strong>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        )}
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={closeMedicineModal}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* PAYMENT MODAL */}
            {showPaymentModal && selectedPaymentBill && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Payment - Bill #{formatBillNo(selectedPaymentBill.med_bill_id)}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowPaymentModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <div className="alert alert-info mb-3">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <strong>Patient:</strong> {selectedPaymentBill.med_bill_patient_number}<br />
                                            <strong>Bill No:</strong> {formatBillNo(selectedPaymentBill.med_bill_id)}
                                        </div>
                                        <div className="col-md-6 text-end">
                                            <strong>Total:</strong> ₹{Number(selectedPaymentBill.med_bill_final_amt || 0).toFixed(2)}<br />
                                            <strong>Paid:</strong> ₹{Number(selectedPaymentBill.med_bill_paid || 0).toFixed(2)}<br />
                                            <strong className="text-danger">Due:</strong> ₹{Number(selectedPaymentBill.med_bill_due || 0).toFixed(2)}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Payment Mode *</label>
                                        <select
                                            className="form-control"
                                            value={paymentMode}
                                            onChange={(e) => setPaymentMode(e.target.value)}
                                            style={{ color: paymentMode === '' ? '#999' : '#000' }}
                                        >
                                            <option value="" disabled>-- Select Payment Mode --</option>
                                            <option value="Cash">Cash</option>
                                            <option value="Card">Card</option>
                                            <option value="Online">Online</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Payment Amount *</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter amount"
                                            value={paymentAmount}
                                            onChange={(e) => setPaymentAmount(e.target.value)}
                                            max={selectedPaymentBill.med_bill_due}
                                            step="0.01"
                                        />
                                        <small className="text-muted">
                                            Maximum: ₹{Number(selectedPaymentBill.med_bill_due || 0).toFixed(2)}
                                        </small>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Received By *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter name"
                                            value={paymentReceivedBy}
                                            readOnly
                                            style={{ backgroundColor: '#e9ecef' }}
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Remarks (Optional)</label>
                                        <textarea
                                            className="form-control"
                                            rows="2"
                                            placeholder="Optional remarks"
                                            value={paymentRemarks}
                                            onChange={(e) => setPaymentRemarks(e.target.value)}
                                        ></textarea>
                                    </div>
                                </div>

                                {paymentHistory.length > 0 && (
                                    <>
                                        <hr />
                                        <h6 className="mb-3">Payment History</h6>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            <table className="table table-sm table-bordered">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th style={{width: '40px'}}>Sl.</th>
                                                        <th>Date & Time</th>
                                                        <th>Mode</th>
                                                        <th className="text-end">Amount</th>
                                                        <th>Received By</th>
                                                        {isAdmin && <th style={{width: '80px'}}>Action</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paymentHistory.map((payment, index) => (
                                                        <tr key={payment.payment_id}>
                                                            <td>{index + 1}</td>
                                                            <td>{new Date(payment.payment_datetime).toLocaleString()}</td>
                                                            <td>
                                                                <span className={`badge ${
                                                                    payment.payment_mode === 'Cash' ? 'bg-success' :
                                                                    payment.payment_mode === 'Card' ? 'bg-primary' :
                                                                    'bg-info'
                                                                }`}>
                                                                    {payment.payment_mode}
                                                                </span>
                                                            </td>
                                                            <td className="text-end">₹{parseFloat(payment.payment_amount).toFixed(2)}</td>
                                                            <td>{payment.payment_received_by}</td>
                                                            {isAdmin && (
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => handleDeletePayment(payment.payment_id)}
                                                                    >
                                                                        <i className="ri-delete-bin-line"></i>
                                                                    </button>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot className="table-light">
                                                    <tr>
                                                        <th colSpan="3" className="text-end">Total Paid:</th>
                                                        <th className="text-end">
                                                            ₹{paymentHistory.reduce((sum, p) => sum + parseFloat(p.payment_amount), 0).toFixed(2)}
                                                        </th>
                                                        <th colSpan={isAdmin ? "2" : "1"}></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowPaymentModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleAddPayment}
                                >
                                    <i className="ri-check-line me-1"></i>
                                    Add Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* PRINT OPTIONS MODAL */}
            {showPrintModal && selectedPrintBill && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="ri-printer-line me-2"></i>
                                    Print Options
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowPrintModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <div className="d-grid gap-3">
                                    <button
                                        className="btn btn-outline-primary btn-lg"
                                        onClick={() => handlePrintSelection('pharmacy')}
                                    >
                                        <i className="ri-file-text-line me-2"></i>
                                        Pharmacy Bill
                                        <div className="small text-muted mt-1">Print original sale invoice with payment history</div>
                                    </button>

                                    <button
                                        className="btn btn-outline-warning btn-lg"
                                        onClick={() => handlePrintSelection('return')}
                                    >
                                        <i className="ri-file-damage-line me-2"></i>
                                        Return Bill
                                        <div className="small text-muted mt-1">Print return/refund invoice (if exists)</div>
                                    </button>

                                    <button
                                        className="btn btn-outline-success btn-lg"
                                        onClick={() => handlePrintSelection('all')}
                                    >
                                        <i className="ri-file-copy-2-line me-2"></i>
                                        Print All
                                        <div className="small text-muted mt-1">Print both pharmacy and return bills</div>
                                    </button>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowPrintModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Sales;